import React, { Component } from 'react';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import { InfoContainer, InfoTitle, InfoParagraph, InfoWrapper, TitleWrapper, HeaderWrapper, SeparatorRow, ListItem, UnorderedList, Link, CloseInfo, CloseInfoIcon } from './PantallaInfoElements';

export default class InfoCookies extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <InfoContainer id="InfoContainerCookies" infoOpen={this.props.infoOpen} mapHeight={this.props.mapHeight}>
        <HeaderWrapper>
          <TitleWrapper>
            <InfoTitle id="InfoTitleCookies" aria-label={getTranslatedKey('politicaGaletesTitle')} title={getTranslatedKey('politicaGaletesTitle')} fontSizeEnabled={this.props.fontSizeEnabled}>
              {getTranslatedKey('politicaGaletesTitle')}
            </InfoTitle>
            <CloseInfo title={getTranslatedKey('tancar')} onClick={() => this.props.toggleInfo()} aria-label={getTranslatedKey('aria_closeInfo')}>
              <CloseInfoIcon title={getTranslatedKey('tancar')} fontSizeEnabled={this.props.fontSizeEnabled}>
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
              </CloseInfoIcon>
            </CloseInfo>
          </TitleWrapper>

          <SeparatorRow id="SeparatorRowHeaderCatalog" />
        </HeaderWrapper>
      </InfoContainer>
    );
  }
}
